import axios from 'axios';
import { withRetry } from './apiRetry';

const API_URL = '';

const adminApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Retry transient failures (network errors, 502/503/504) before giving up
withRetry(adminApi);

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const message = error.response?.data?.detail || 'Session expired';
      if (message.toLowerCase().includes('expired') || message.toLowerCase().includes('session')) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        window.location.href = '/admin/login?session_expired=true';
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;
